import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import { ApplyJobService } from "src/app/shared/services/apply-job.service";
import { LocalStorageService } from "src/app/shared/services/local-storage.service";
import { AuthService } from "src/app/store/auth/auth.service";
declare var Calendly: any;


@Component({
    selector: "app-employer-profile",
    templateUrl: "./employer-profile.component.html",
    styleUrl: "./employer-profile.component.scss",
})
export class EmployerProfileComponent {
    userO = this.authService.userO;
    updateEmployerProfile: FormGroup | any;
    lookingFor: FormGroup | any;
    isEmailDisabled = true;
    userInfo: any = {};
    private userSub: Subscription;
    australianPhoneNumberPattern = /^(?:\+?61|0)[2-478](?:[ -]?[0-9]){8}$/;
    loader:boolean = false;
    lookingForLoader: boolean = false;
    jobCategory: any[] = [];
    category: any[] = [];
    phonePatterns: { [key: string]: RegExp } = {
        "+93": /(?:\+?93|0093)?0?7[0-9]{8}/, // Afghanistan
        "+355": /^(?:\+?355|0)[1-9][0-9]{8}$/, // Albania
        "+213": /^(?:0)?(5[0-9]{2}[ \-]?[0-9]{2}[ \-]?[0-9]{2}[ \-]?[0-9]{2}|6[0-9]{2}[ \-]?[0-9]{2}[ \-]?[0-9]{2}[ \-]?[0-9]{2}|7[0-9]{2}[ \-]?[0-9]{2}[ \-]?[0-9]{2}[ \-]?[0-9]{2})$/, // Algeria
        "+376": /^(?:\+?376[\s-]?|0)[1-9][0-9]{5}$/, // Andorra
        "+244": /^(?:\+?244[\s-]?|0)[1-9][0-9]{8}$/, // Angola
        "+55": /^(?:\+55[\s-]?|0)(?:[1-9][0-9])[\s-]?[0-9]{4}[\s-]?[0-9]{4,5}$/, // Brazil
        "+54": /^(?:\+54[\s-]?|0)?(?:[1-9][0-9]{1,2}[\s-]?)?[0-9]{8}$/, // Argentina
        "+374": /^(?:\+?374|0)[1-9][0-9]{7}$/, // Armenia
        "+61": /^(?:\+?61|0)[2-478](?:[ -]?[0-9]){8}$/, // Australia
        "+43": /^(?:\+?43|0)[1-9][0-9]{3,11}$/, // Austria
        "+994": /^(?:\+994[\s-]?|0)?[1-9][0-9]{8,9}$/, // Azerbaijan
        "+359": /^(?:\+359[\s-]?|0)?[1-9][0-9]{6,7}$/, // Bulgaria
        "+973": /^(?:\+973[\s-]?|0)?[1-9][0-9]{7}$/, // Bahrain
        "+880": /^(?:\+880[\s-]?|0)?[1-9][0-9]{8,9}$/, // Bangladesh
        "+591": /^(?:\+591[\s-]?|0)?[1-9][0-9]{7,8}$/, // Bolivia
        "+375": /^(?:\+375[\s-]?|0)?[1-9][0-9]{8}$/, // Belarus
        "+32": /^(?:\+32[\s-]?|0)?[1-9][0-9]{7}$/, // Belgium
        "+501": /^(?:\+501[\s-]?|0)?[0-9]{7}$/, // Belize
        "+229": /^(?:\+229[\s-]?|0)?[1-9][0-9]{7}$/, // Benin
    };

    countryCode: any;

    constructor(
        private readonly fb: FormBuilder,
        private readonly authService: AuthService,
        private readonly localStorageService: LocalStorageService,
        private readonly ngxToaster: ToastrService,
        private readonly applyJobService:ApplyJobService
    ) {}

    ngOnInit(): void {
        this.userSub = this.userO.subscribe((data) => {
            console.log(data);
            if (!data) return;
            if (data?.isData === true) {
                this.userInfo = data?.body;
                console.log('userInfooooooo',this.userInfo?.email)
                const { result, ...bodyWithoutResult } = data;
                this.localStorageService.setUserData(bodyWithoutResult);
                if (data?.result) {
                    this.loader=false
                    this.ngxToaster.success(data?.result);
                }
            } else {
                this.loader=false
                this.ngxToaster.error(data?.result);
            }
        });

        this.initEmployerUpdateForm();
        this.initLookingForForm();
        this.setExistingCandidateData();
        this.getJobCategories();
    }

    initEmployerUpdateForm() {
        this.updateEmployerProfile = this.fb.group({
            firstName: ["", [Validators.required]],
            middleName: [""],
            lastName: ["", [Validators.required]],
            email: [
                { value: this.userInfo.email, disabled: this.isEmailDisabled },
            ],
            businessName: ["", [Validators.required]],
            // emailAddress: ["", [Validators.required]],
            phoneNumber: [
                "",
                [
                    Validators.required,
                    ,
                    
                ],
            ],
            // collegeName: ["", [Validators.required]],
            collegeAddress: [""],
            // country: [""],
        });
    }

    initLookingForForm(){
        this.lookingFor = this.fb.group({
            questionText: ["", [Validators.required]],
            category:[""]
        });
    }

   
    openCalendly(): void {
        // Use Calendly's popup widget to open the scheduling interface
        Calendly.initPopupWidget({
            url: "https://calendly.com/accounts-magnusrecruitment/15min", // Replace with your scheduling link
        });
    }

    setExistingCandidateData() {
        const phoneNumber = this.userInfo.phoneNumber;
        const countryCodeMatch = phoneNumber.match(/^(\+\d{1,4})\s/);
        this.countryCode = countryCodeMatch ? countryCodeMatch[1] : "";
        console.log("countrycode", this.countryCode);
        const localNumber = phoneNumber.replace(this.countryCode + " ", "");
        console.log("localNumber", localNumber);

        this.updateEmployerProfile.patchValue({
            firstName:this.userInfo.firstName,
            middleName:this.userInfo.middleName,
            lastName:this.userInfo.lastName,
            email: this.userInfo.email,
            businessName: this.userInfo.businessName,
            phoneNumber: this.userInfo.phoneNumber, 
            countryCode: this.countryCode,
            collegeName: this.userInfo.collegeName,
            collegeAddress: this.userInfo.collegeAddress,
            // country: this.userInfo.country,
        });
    }

    //payload of update employee
    initUpdateEmployeePayload() {
        const formValue = this.updateEmployerProfile.value;
        return {
            firstName: formValue.firstName,
            middleName: formValue.middleName,
            lastName: formValue.lastName,
            email: this.userInfo?.email,
            businessName: formValue.businessName,
            phoneNumber: formValue.phoneNumber,
            // collegeName: formValue.collegeName,
            collegeAddress: formValue.collegeAddress,
            // country: formValue.country.country,
        };
    }

    //payload of looking for?
    lookingForPayload(){
        const formValue = this.lookingFor.value;
        return {
            questionText: formValue?.questionText,
            categories: this.category
        }
    }

        //job category drop-down list
        getJobCategories() {
            this.applyJobService.getAllJobCategoriesForFilter()
                .subscribe((jobListing: any) => {
                    console.log('bbbb',jobListing)
                    this.jobCategory = jobListing.body.map((job: any) => ({
                        category: `${job.categoryName}  (${job.jobCount})`,
                        originalCategory: job.categoryName,
                        totalJobs: job.jobCount,
                    }));
                });
        }

      //on select of job category
       onSelectCategory(selectedItems: any) {
        this.category = [];
        selectedItems.value.forEach((item: any) => {
            console.log(item.originalCategory);
            if (!this.category.includes(item.originalCategory)) {
                this.category.push(item.originalCategory);
            }
        });
       }

        // // phone number validation
        // onChangePhoneNumber(value: string) {
        //     const countryCode = this.countryCode;
        //     const phonePattern =this.phonePatterns[countryCode] || this.phonePatterns[""];
    
        //     const phoneNumberControl =this.updateEmployerProfile.get("phoneNumber");
        //     if (phoneNumberControl) {
        //         phoneNumberControl.setValidators([
        //             Validators.required,
        //             Validators.pattern(phonePattern),
        //         ]);
        //         phoneNumberControl.updateValueAndValidity(); // Revalidate after updating validators
    
        //         // Check the validity of the current value based on the new pattern
        //         const isValid = phonePattern.test(value);
        //         console.log("Phone Number Valid:", isValid);
        //     }
        // }

    submit() {
        const payload = this.initUpdateEmployeePayload();
        console.log("Update Employee Payload:", payload);
        if(this.updateEmployerProfile.invalid){
            this.touchFormControls()
            return
        }
        this.loader = true
        this.authService.updateEmployeeProfileDetails(
            this.initUpdateEmployeePayload(),
            this.userInfo._id
        );
    }

    submitLookingFor() {
        if(this.lookingFor.invalid){
            this.touchFormControlsLookingFor();
            return
        }
        this.lookingForLoader = true
         this.authService.employerLookingForRequest(
                this.userInfo._id,
                this.lookingForPayload(),
            ).subscribe({
            next: (response: any) => {
                const { result, body, isData } = response;
                if (isData === true) {
                    this.lookingFor.reset();
                    this.category = null 
                    this.lookingForLoader = false
                    this.ngxToaster.success(result);
                }else if(isData === false){
                    this.lookingForLoader = false
                    this.ngxToaster.success(result);
                }
            },
            error: (error) => {
                const errorMessage = error?.error.result;
                this.lookingForLoader = false
                this.ngxToaster.error(errorMessage);
            },
        });
        // console.log("Payload: ", this.lookingForPayload()); // Debugging output
        // this.authService.employerLookingForRequest(
        //     this.userInfo._id,
        //     this.lookingForPayload(),
        // ).subscribe((res:any)=>{

        // });
    }
    
    touchFormControls() {
        Object.keys(this.updateEmployerProfile.controls).forEach((key) => {
            this.updateEmployerProfile.get(key)?.markAsTouched();
        });
    }

    touchFormControlsLookingFor() {
        Object.keys(this.lookingFor.controls).forEach((key) => {
            this.lookingFor.get(key)?.markAsTouched();
        });
    }

    //ngx-selector-dropDown-Configuration
    config = {
        displayKey: "country",
        search: true,
        height: "auto",
        placeholder: "Select Country",
        customComparator: () => {},
        moreText: "more",
        noResultsFound: "No results found!",
        searchPlaceholder: "Search",
        searchOnKey: "country",
        clearOnSelection: false,
        inputDirection: "ltr",
    };


       //ngx-selector-dropDown-Configuration for job category
       configCategory = {
        displayKey: "category",
        search: true,
        height: "auto",
        placeholder: "Job Category",
        customComparator: () => {},
        moreText: "more",
        noResultsFound: "No results found!",
        searchPlaceholder: "Search",
        searchOnKey: "category",
        clearOnSelection: false,
        resetSelection: true, 
        inputDirection: "ltr",
        multiple: true,
    };

    ngOnDestroy() {
        this.userSub.unsubscribe();
    }
}
